import React, { useMemo, useState } from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useFetchNachrichten } from '../../../hooks/FetchNachrichten';
import { useNavigate } from 'react-router-dom';
import { T, getFieldNamefromDataPath, getLabelFromDataPath } from '../../../utils/helper';
import { deDE, DataGridPremium, LicenseInfo } from '@mui/x-data-grid-premium';
import { get } from 'lodash';
import { MUIX_LICENSE } from '../../../lib/constants/constant';
import { DisplayDateTime } from '../../../utils/formats';
import CreateNachricht from '../../../components/ui-component/nachrichten/CreateNachricht';
import SendIcon from '@mui/icons-material/Send';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';

import Schema from '../../../lib/paths/portal45nachricht_FULL_Paths.json';
import { useFetchApplicationsForNachrichten } from '../../../hooks/FetchApplications';
import CreateForm from '../../../components/ui-component/form-component/create-form/CreateForm';
const P = Schema.attributes;

LicenseInfo.setLicenseKey(MUIX_LICENSE);
function MeineNachrichten() {
	const navigate = useNavigate();

	const [ordnerValue, setOrdnerValue] = useState({ ordner: 'Posteingang' });

	const [showCreateNachricht, setShowCreatenachricht] = useState<boolean>(false);
	const { loading, data, error } = useFetchNachrichten(showCreateNachricht, get(ordnerValue, 'ordner', 'Posteingang'));
	const { data: applications } = useFetchApplicationsForNachrichten();

	const rows = useMemo(() => {
		return (
			data?.map((ele) => ({
				id: get(ele, 'id'),
				[getFieldNamefromDataPath(P.Allgemein_Betreff.path)]: T(get(ele, P.Allgemein_Betreff.path)),
				createdAt: DisplayDateTime(get(ele, 'attributes.createdAt')),
				ordner: T(get(ele, P.Allgemein_Ordner.path)),
				read: get(ele, P.Allgemein_gelesen.path),
			})) ?? []
		);
	}, [data]);

	const columns = useMemo(() => {
		let column: any[] = [
			{ field: 'id', headerName: 'ID' },
			{
				field: getFieldNamefromDataPath(P.Allgemein_Betreff.path),
				headerName: getLabelFromDataPath(P.Allgemein_Betreff.path),
				flex: 1,
			},
			{ field: 'ordner', headerName: 'Ordner', flex: 1 },
			{
				field: 'createdAt',
				headerName: 'Erstellt am',
				flex: 1,
			},
		];

		if (get(ordnerValue, 'ordner') === 'Posteingang') {
			column.push({
				field: 'read',
				headerName: 'Gelesen',
				sortable: false,
				width: 90,
				disableColumnMenu: true,
				renderCell: (params: any) =>
					params.row.read ? <DraftsOutlinedIcon fontSize="small" /> : <MarkunreadIcon fontSize="small" />,
			});
		}
		return column;
	}, [ordnerValue]);

	if (error) console.error(' error', error);

	const formSTRUC = [
		{
			fields: [
				{
					label: 'Ordner',
					path: 'ordner',
					type: 'singleSelect',
					options: [
						{ label: 'Posteingang', value: 'Posteingang' },
						{ label: 'Postausgang', value: 'Postausgang' },
					],
					sx: { width: '300px' },
				},
			],
		},
	];
	return (
		<>
			<CreateNachricht
				showNachrichtDialog={showCreateNachricht}
				handleCloseDialog={() => setShowCreatenachricht(false)}
				applications={applications as any[]}
			/>
			<Container>
				<Stack direction={'row'} justifyContent={'space-between'}>
					<Typography variant="h3">Meine Nachrichten</Typography>
					<Button onClick={() => setShowCreatenachricht(true)} endIcon={<SendIcon />}>
						{' '}
						Neue Nachricht
					</Button>
				</Stack>
				<CreateForm
					formStruc={formSTRUC}
					formValues={ordnerValue}
					updateFormValuesFunc={(_path: string, value: any) => setOrdnerValue({ ordner: value })}
				/>
				<Box sx={{ mt: '2rem' }}>
					<DataGridPremium
						autoHeight
						loading={loading}
						rows={rows}
						columns={columns}
						onRowClick={(param) => navigate(`/meine-nachrichten/nachricht-details/${param.id}`)}
						pinnedColumns={{ right: ['read'] }}
						getRowClassName={(params) => {
							return `${params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'} message-read-status--${
								params.row.read
							}--message-folder-${params.row.ordner}`;
						}}
						disableColumnMenu
						localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
					/>
				</Box>
			</Container>
		</>
	);
}

export default MeineNachrichten;
